const REPORT_MODEL_CLASS_NAME = 'Report'

const REPORT_MODEL_KEY = {
  COMMENTS: 'comments',
  USER: 'user'
  // Foreign keys
}

export {
  REPORT_MODEL_KEY,
  REPORT_MODEL_CLASS_NAME
}
